import { css } from 'styled-components';
import { themeGet } from '../../../theme/utils';

const tag = css`
  border: 2px solid ${themeGet.colors('primary')};
  color: ${themeGet.colors('kilamanjaro')};
  &:active {
    background-color: ${themeGet.colors('desertStorm')};
    color: ${themeGet.colors('primaryDark')};
  }
  box-shadow: none;
  &:hover {
    color: ${themeGet.colors('primary')};
    box-shadow: none;
  }
  padding: 0 ${themeGet.space(2)};
` as any;

export default tag;
